import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import CreateComponents from "../pages/Components/Create";
import EditComponents from "../pages/Components/Edit";
import ComponentsList from "../pages/Components/List";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import CreateNavigation from "../pages/Navigation/Create";
import EditNavigation from "../pages/Navigation/Edit";
import NavigationList from "../pages/Navigation/List";
import Overview from "../pages/Overview";
import CreatePages from "../pages/Pages/Create";
import EditPages from "../pages/Pages/Edit";
import PagesList from "../pages/Pages/List";
import CreatePoupModal from "../pages/PopupModal/Create";
import EditPopupModal from "../pages/PopupModal/Edit";
import PopupModalList from "../pages/PopupModal/List";
import PrivateRoute from "./PrivateRoute";
import CreateTheme from "../pages/Theme/CreateTheme";
import { getKey } from "../helpers/sessionKey";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route path="/website-builder/pages/edit/:id" element={<EditPages />} />
      <Route
        path="/website-builder/popup-modal/edit/:id"
        element={<EditPopupModal />}
      />
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={"/website-builder"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <Overview />
            )
          }
        />
        <Route path="/website-builder/overview" element={<Overview />} />

        {/* INFO: Navigation Section Routes starts here */}
        <Route
          path="/website-builder/navigation"
          element={<NavigationList />}
        />
        <Route
          path="/website-builder/navigation/create"
          element={<CreateNavigation />}
        />
        <Route
          path="/website-builder/navigation/edit/:id"
          element={<EditNavigation />}
        />
        {/* INFO: Navigation Section Routes ends here */}

        {/* INFO: Pages Section Routes starts here */}
        <Route path="/website-builder/pages" element={<PagesList />} />
        <Route path="/website-builder/pages/create" element={<CreatePages />} />

        {/* INFO: Pages Section Routes ends here */}

        {/* INFO: Popup Modal Section Routes starts here */}
        <Route
          path="/website-builder/popup-modal"
          element={<PopupModalList />}
        />
        <Route
          path="/website-builder/popup-modal/create"
          element={<CreatePoupModal />}
        />

        {/* INFO: Popup Modal Section Routes ends here */}

        {/* INFO: Components Section Routes starts here */}
        <Route
          path="/website-builder/components"
          element={<ComponentsList />}
        />
        <Route
          path="/website-builder/components/create"
          element={<CreateComponents />}
        />
        <Route
          path="/website-builder/components/edit/:id"
          element={<EditComponents />}
        />
        <Route path="/website-builder/theme" element={<CreateTheme />} />
        {/* INFO: Components Section Routes ends here */}
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
